import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { BaseFieldComponent } from '../base-field.component'
import {
  GetUserSignatureData,
  SignatureEditorType,
} from '@tv3/containers/documents/shared/signature-editor/signature-editor-dialog.component'
import { SignatureEditorDialogService } from '@tv3/containers/documents/shared/signature-editor/signature-editor-dialog.service'

@Component({
  templateUrl: './initials.component.html',
  styleUrls: ['./initials.component.scss', '../global.scss'],
})
export class InitialsFieldComponent extends BaseFieldComponent implements OnInit {
  @Output() valueChange = new EventEmitter<GetUserSignatureData>()

  signatureStyle: any = {}

  constructor(private signatureEditorDialog: SignatureEditorDialogService) {
    super()
  }

  ngOnInit() {}

  setValue({ signature, size }: GetUserSignatureData) {
    this.field.value = signature
    if (size.width / this.field.width > size.height / this.field.height) {
      this.signatureStyle = { width: '100%' }
    } else {
      this.signatureStyle = { height: '100%' }
    }
  }

  showAddInitials() {
    this.signatureEditorDialog
      .open(SignatureEditorType.GetUserSignature)
      .afterClosed()
      .subscribe((data: GetUserSignatureData) => {
        this.valueChange.emit(data)
        this.setValue(data)
      })
  }
}
